export default {
	"indexTitle": {
		"title1": "注册",
		"title2": "登入",
		"title3": "手机下载",
		"title4": "充值",
		"title5": "提现",
		"title6": "体育",
		"title7": "真人",
		"title8": "老虎机",
		"title9": "棋牌",
		"title10": "捕鱼",
		"title11": "动物竞技",
		"title12": "电竞",
		"title13": "彩票",
		"title14": "优惠活动",
		"title15": "手机下载",

		"title16": "访问历史",
		"title17": "开始游戏",
		"title18": "最新消息",
		"title19": "请注意使用支付宝、八达通、tap&go、BOC等类别银行入款，请必须选择转数快并核对收款人英文全名！",
		"title20": "全部优惠",
		"title21": "申请此优惠",
		"title22": "我要遊戲",
		"title23": "余额",
		"title24": "我的帐户",
		"title25": "VIP",
		"title26": "充值",
		"title27": "提款",
		"title28": "邀请好友",
		"title29": "任务日志",
		"title30": "优惠中心",
		"title31": "游戏记录",
		"title32": "财务记录",
		"title33": "公告中心",
		"title34": "推广分销",
		"title35": "直属成员",
		"title36": "我的佣金",
		"title37": "规则说明",
		"title38": "团队人数",
		"title39": "今日团队新增",
		"title40": "直属人数",
		"title41": "今日直属新增",
		"title42": "今日团队流水",
		"title43": "今日直属流水",
		"title44": "推广收益",
		"title45": "奖金",
		"title46": "下线人数",
		"title47": "预估可以获得高额奖金",
		"title48": "个人信息",
		"title49": "推荐代码",
		"title50": "邀请链接",
		"title51": "邀请二维码",
		"title52": "推广工具",
		"title53": "下载",
		"title54": "我的账户",
		"title55": "新密码",
		"title56": "修改取款密码",
		"title57": "旧密码",
		"title58": "必填",
		"title59": "请输入登入密码",
		"title60": "确认新密码",
		"title61": "取消",
		"title62": "更新",
		"title63": "请输入旧密码",
		"title64": "请输入新密码",
		"title65": "两次密码不同",
		"title66": "更新失败",
		"title67": "登录密码",
		"title68": "新取款密码",
		"title69": "6~10位英文与数字组合(可包含特殊字元)",
		"title70": "确认取款密码",
		"title71": "请输入登录密码",
		"title72": "请输入新取款密码",
		"title73": "存款方式选项",
		"title74": "优惠",
		"title75": "暂无资料",
		"title76": "转数快",
		"title77": "便利商店增值",
		"title78": "无充值限额",
		"title79": "手续费",
		"title80": "无手续费",
		"title81": "请输入充值金额",
		"title82": "请输入付款姓名",
		"title83": "充值赠送",
		"title84": "请选择",
		"title85": "获取付款信息",
		"title86": "支付教程",
		"title87": "1.请选择支付通道后，填入金额，点击提交。",
		"title88": "2.跳转第三方支付页面后，依据页面程序进行存款并在时限内完成。",
		"title89": "3.支付完成后，等待页面显示支付成功信息后，再将页面关闭，以免发生掉单的情形。",
		"title90": "4.等待第三方平台确认后，系统将自动添加到您的帐号。",
		"title91": "5.支付未到帐？无法支付？请联系【在线客服】进行咨询。",
		"title92": "充值金额",
		"title93": "请记录以下收款资讯,并汇款",
		"title94": "收款帐号",
		"title95": "收款帐户名",
		"title96": "收款二维码",
		"title97": "充值地址",
		"title98": "返回重新输入",
		"title99": "确认充值",
		"title100": "复制成功！",
		"title101": "开始",
		"title102": "结束",
		"title103": "可查询当日往前31天的资料",
		"title104": "查询",
		"title105": "存款总计",
		"title106": "提款总计",
		"title107": "优惠总计",
		"title108": "返水记录",
		"title109": "手动调整记录",
		"title110": "推荐记录",
		"title111": "任务奖励记录",
		"title112": "*存取數據時可能會延遲，若未找到遊戲紀錄，請稍後重試。 總覽資料固定GMT+8時間做加總，只顯示近10日資料",
		"title113": "产品类型",
		"title114": "游戏",
		"title115": "日期",
		"title116": "总投注",
		"title117": "总有效投注",
		"title118": "总输赢",
		"title119": "已结算",
		"title120": "投注额",
		"title121": "交易编号",
		"title122": "暂无记录",
		"title123": "个人资料",
		"title124": "银行卡资料",
		"title125": "所有钱包",
		"title126": "修改 登录/取款 密码",
		"title127": "推荐码",
		"title128": "玩家帐号",
		"title129": "真实姓名",
		"title130": "手机号码",
		"title131": "注册时间",
		"title132": "总金额",
		"title133": "新增银行卡",
		"title134": "银行卡号",
		"title135": "开户人名字",
		"title136": "必须与您的银行帐户姓名一致，否则无法进行取款",
		"title137": "收款银行",
		"title138": "银行账号",
		"title139": "请输入您的银行账号",
		"title140": "开户行网点",
		"title141": "请输入您的开户行网点",
		"title142": "确认",
		"title143": "请输入开户人名字",
		"title144": "请输入收款银行",
		"title145": "请输入银行账号",
		"title146": "请输入开户行网点",
		"title147": "倒数时间",
		"title148": "每日存款",
		"title149": "港元以上",
		"title150": "活动点数",
		"title151": "点",
		"title152": "累计登入",
		"title153": "天以上",
		"title154": "已完成",
		"title155": "可领取",
		"title156": "任务准备中",
		"title157": "平台公告",
		"title158": "总计",
		"title159": "申请时间",
		"title160": "审核时间",
		"title161": "待确认",
		"title162": "成功",
		"title163": "失败",
		"title164": "实际金额",
		"title165": "备注",
		"title166": "订单号",
		"title167": "更多内容",
		"title168": "VIP等级",
		"title169": "当前等级",
		"title170": "VIP权益说明",
		"title171": "晋级",
		"title172": "条件",
		"title173": "通过",
		"title174": "当前积分",
		"title175": "恭喜达成",
		"title176": "专属特权",
		"title177": "等级不足",
		"title178": "生日礼金",
		"title179": "领取",
		"title180": "积分历程",
		"title181": "等级升降",
		"title182": "领取记录",
		"title183": "提款金额",
		"title184": "稽核总扣除",
		"title185": "提款密码",
		"title186": "实际提领",
		"title187": "提款金额应介于 1.00 与 10.00 之间",
		"title188": "请先绑定银行卡",
		"title189": "请输入提现金额",
		"title190": "请输入提现密码",
		"title191": "玩家登录",
		"title192": "帐号",
		"title193": "密码",
		"title194": "还未注册?立即点击",
		"title195": "忘记帐号",
		"title196": "忘记密码",
		"title197": "请输入玩家账号",
		"title198": "请输入玩家密码",
		"title199": "玩家帐户必须6-12位",
		"title200": "China (中国)",
		"title201": "Hong Kong (香港)",
		"title202": "重新输入",
		"title203": "立即注册",
		"title204": "请输入帐号",
		"title205": "请输入密码",
		"title206": "请输入手机号",
		"title207": "每日任务",
		"title208": "轮盘",
		"title209": "推荐进度",
		"title210": "联系我们",
		"title211": "关于我们",
		"title212": "登出",
		"title213": "免费注册",
		"title214": "体育赛事",
		"title215": "真人娱乐",
		"title216": "电子游戏",
		"title217": "棋牌",
		"title218": "捕鱼游戏",
		"title219": "动物竞技",
		"title220": "电子竞技",
		"title221": "Android 扫一扫",
		"title222": "iOS 手机扫一扫",
		"title223": "立即游戏",
		"title224": "活动时间:",

		"title225": "取款密码",
		"title226": "支付通道",
		"title227": "全部",
		"title228": "玩家充值",
		"title229": "存款记录",
		"title230": "帮助中心",
		"title231": "存款帮助",
		"title232": "您好,",
		"title233": "银行卡管理",
		"title234": "每日任务",
		"title235": "累计任务",
		"title236": "期间任务",
		"title237": "签到任务",
		"title238": "未开通",
		"title239": "修改提款密码",
		"title240": "玩家账号",
		"title241": "轮盘点数",
		"title242": "真实姓名",
		"title243": "手机号码",
		"title244": "生日日期",
		"title245": "注册时间",
		"title246": "上次登录密码",
		"title247": "vip记录",
		"title248": "提款记录",
		"title249": "可提款金额",
		"title250": "优惠稽核",
		"title251": "扣除额",
		"title252": "行政费用",
		"title253": "手续费",
		"title254": "优惠金",
		"title255": "常态稽核",
		"title256": "第",
		"title257": "天",
		"title258": "金额",
		"title259": "获取金额：",
		"title260": "码量：",
		"title261": "签到",
		"title262": "已签到",
		"title263": "总签到天数：",
		"title264": "总签到收益：",
		"title265": "当日充值金额：",
		"title266": "当日有效投注：",
		"title267": "要求存款数量：",
		"title268": "要求有效码量数量：",
		"title269": "转盘次数：",
		"title270": "次",
		"title271": "今日已完成该任务",
		"title272": "未达标",

		"title273": "首页",
		"title274": "优惠",
		"title275": "赚钱",
		"title276": "账户",
		"title277": "未到签到天数",
		"title278": "签到条件",
		"title279": "已达成!",
		"title280": "需先完成身份认证金级",
		"title281": "即可参与此活动",
		"title282": "签到送奖金",
		"title283": "活动天数共",
		"title284": "总奖金",
		"title285": "选择币种",
		"title286": "请输入英文名字",
		"title287": "账号最少6位",
		"title288": "银行账户",
		"title289": "最低：",
		"title290": "最高：",
		"title291": "充值额度",
		"title292": "充值额度最低",
		"title293": "充值额度最高",
		"title294": "登录状态失效，请重新登录",
		"title295": "银行卡名称",
		"title296": "开户银行",
		"title297": "银行卡账号",
		"title298": "请输入6位数字提款密码",
		"title299": "此动作将把所有余额转回主钱包，是否继续？",
		"title300": "取消",
		"title301": "继续",
		"title302": "提款密码6位数",
		"title303": "资金回收",
		"title304": "客服",
		"title305": "尚餘打碼量",
		"title306": "实时返水",
		"title307": "领取",
		"title308": "最低充值金额",
		"title309": "下载苹果版",
		"title310": "支持苹果",
		"title311": "以上",
		"title312": "下载安卓版",
		"title313": "支持安卓",
		"title314": "微信玩家请用手机浏览器",
		"title315": "点击复制网址",

		"title316": "活动奖品",
		"title317": "我的奖品",
		"title318": "转盘",
		"title319": "赠送彩金：",
		"title320": "要求真人有效投注数量：",
		"title321": "要求捕鱼有效投注数量：",
		"title322": "要求电子有效投注数量：",
		"title323": "要求彩票有效投注数量：",
		"title324": "要求体育有效投注数量：",
		"title325": "要求棋牌有效投注数量：",
		"title326": "要求其他有效投注数量：",
		"title327": "百家乐",

		"title328": "实时返水",
		"title329": "点击领取",
		"title330": "元",
		"title331": "真人返水金额：",
		"title332": "体育返水金额：",
		"title333": "电子返水金额：",
		"title334": "棋牌返水金额：",
		"title335": "领取说明",
		"title336": "领取时间为16:00:00-23:59:59,如未在此时间段内领取则清零",
		"title337": "仅提供14天内交易资料查询",
		"title338": "捕鱼返水金额：",
		"title339": "电竞返水金额：",
		"title340": "动物电竞返水金额：",
		"title341": "主钱包",
		"title342": "游戏钱包",
		"title343": "线路选择",
		"title344": "客服（线路一）",
		"title345": "客服（线路二）",
		"title346": "有效投注",
		"title347": "不参与活动",
		"title348": "签到活动",
		"title349": "轮盘抽奖",
		"title350": "红包活动",
		"title351": "选单",
		"title352": "返回",
		"title353": "语言",
		"title354": "法定货币",
		"title355": "加密货币",
		"title356": "存款币种",
		"title357": "存款类型",
		"title358": "银行转账",
		"title359": "转数快",
		"title360": "热门",
		"title361": "选择活动",
		"title362": "不参与活动",
		"title363": "选择网路",
		"title364": "首次存款之會員可至獎金介面申請首存獎金",
		"title365": "存款地址",
		"title366": "复制地址",
		"title367": "全自動到帳 匯率",
		"title368": "收款機構",
		"title369": "訂單編號",
		"title370": "联络信息",
		"title371": "电话验证",
		"title372": "已验证",
		"title373": "验证",
		"title374": "变更登陆密码",
		"title375": "定期变更密码，以保持密码的唯一性和安全性。",
		"title376": "变更支付密码",
		"title377": "请输入舊密码",
		"title378": "6位數字組合（不能輸入其他字元)",
		"title379": "电话验证",
		"title380": "显示所有",
		"title381": "收起",
		"title382": "一般奖金",
		"title383": "輪盤點數",
		"title384": "已领取奖金总额",
		"title385": "详细资讯",
		"title386": "当前可领取",
		"title387": "领取奖励",
		"title388": "紅包獎金",
		"title389": "高达",
		"title390": "签到獎金",
		"title391": "每日真人獎金",
		"title392": "每日體育獎金",
		"title393": "每日電子獎金",
		"title394": "每日棋牌獎金",
		"title395": "每日捕魚獎金",
		"title396": "每日電競獎金",
		"title397": "每日其他遊戲獎金",
		"title398": "每日輪盤點數",
		"title399": "當日存款",
		"title400": "當日流水",
		"title401": "隨機紅包",
		"title402": "優惠規則與條款",
		"title403": "紅包申請：此活動當日存款金額",
		"title404": "流水金額",
		"title405": "當日可以在活動頁面點擊立即領取。",
		"title406": "此活動領取彩金，僅1倍流水提款。",
		"title407": "此活動每位玩家每天可申請一次，隨機紅包金額最高",
		"title408": "每位玩家僅能註冊一個賬戶，如註冊多個賬戶參與活動則被視為多賬戶套利，平台將禁用封鎖該賬戶。",
		"title409": "WG CLUB保留對此活動做出更改，終止的權利，並享受最終解釋權。",
		"title410": "本平台特别推出每日签到奖金制度，只要您完成规定条件，即可获得签到资格，累计签到惊喜更多，每周一00:00签到天数重置！",
		"title411": "只要参与并达成条件，即可于每日获得额外輪盤點數，让您游戏精彩不断!",
		"title412": "只要参与并达成条件，即可于每日获得额外真人奖金，让您游戏精彩不断！",
		"title413": "只要参与并达成条件，即可于每日获得额外體育奖金，让您游戏精彩不断！",
		"title414": "只要参与并达成条件，即可于每日获得额外電子奖金，让您游戏精彩不断！",
		"title415": "只要参与并达成条件，即可于每日获得额外棋牌奖金，让您游戏精彩不断！",
		"title416": "只要参与并达成条件，即可于每日获得额外捕魚奖金，让您游戏精彩不断！",
		"title417": "只要参与并达成条件，即可于每日获得额外電競奖金，让您游戏精彩不断！",
		"title418": "已连续签到",
		"title419": "赌场",
		"title420": "影城",
		"title421": "立即游玩",
		"title422": "今天",
		"title423": "昨天",
		"title424": "近7天",
		"title425": "近30天",
		"title426": "一次显示：100 笔， 总笔数: ",
		"title427": "类型",
		"title428": "时间",
		"title429": "未結算",
		"title430": "已取消",
		"title431": "自订",
		"title432": "状态",
		"title433": "已有帐户",
		"title434": "优惠相关",
		"title435": "记住账号及密码",
		"title436": "近30天已领取优惠总额",
		"title437": "代理佣金",
		"title438": "推荐代码",
		"title439": "佣金奖励",
		"title440": "领取纪录",
		"title441": "昨日好友有效投注",
		"title442": "可领取佣金",
		"title443": "存款提现有什么要求?",
		"title444": "存款最低金額100HKD，提款最低金額100HKD。代理支持USDT提款金額需達10000以上，並聯絡客服綁定USDT提款。佣金需一倍有效投注提款。",
		"title445": "推荐奖金如何计算?",
		"title446": "推薦獎金計算方式，邀請下線註冊並投注即可獲取下線會員的0.3%返水。計算方式如下：下線會員投注金額為5000000，則可以領取佣金為5000000*0.3%= 15000佣金。",
		"title447": "红利奖金多久结算一次?",
		"title448": "代理佣金實時結算，如下線會員投注即刻可以獲取佣金。",
		"title449": "每日动物電競獎金",
		"title450": "只要参与并达成条件，即可于每日获得额外动物電競奖金，让您游戏精彩不断！",
		"title451": "升至",
		"title452": "规则",
		"title453": "等级",
		"title454": "晉級獎金",
		"title455": "週禮金",
		"title456": "月禮金",
		"title457": "转运金",
		"title458": "VIP等级制度",
		"title459": "保级经验值",
		"title460": "升级经验值",
		"title461": "晉升標準",
		"title462": "會員達到相應級別的有效打碼量要求，系統將會自動判斷並晉級相應vip等級。（每晉級相應vip等級有效打碼量將重新計算）。",
		"title463": "保級要求",
		"title464": "會員在達到某VIP等級後，60天內需要完成保級有效打碼量要求（當前等級晉升所需有效打碼量的一半等於保級有效打碼量）。如果在此期間完成晉升，保級要求重新按照當前等級計算。",
		"title465": "降級標準",
		"title466": "會員在60天內，沒有完成相應的保級要求，系統將會自動降級一個等級（每降至相應VIP等級有效投注額將重新計算），相應的優惠也會隨之調整至降級後的等級。",
		"title467": "晉級禮金",
		"title468": "晉級禮金在會員晉升等級後，即可在VIP頁面領取晉級彩金，每個級別的晉級禮金僅能獲得1次，晉級禮金需完成1倍打碼量即可提款。",
		"title469": "VIP周紅包",
		"title470": "VIP紅包每週即可領取一次，紅包金額根據當前等級可領取相應的金額，逢週一00:00更新逾期則無法領取上週紅包彩金，紅包1倍有效打碼量即可提款，每周限參與一次。",
		"title471": "VIP月紅包",
		"title472": "VIP紅包每月即可領取一次，紅包金額根據當前等級可領取相應的金額，逢一號00:00更新逾期則無法領取上月紅包彩金，紅包1倍有效打碼量即可提款，每月限參與一次。",
		"title473": "VIP俱乐部",
		"title474": "复制",
		"title475": "邀请好友",
		"title476": "业绩查询",
		"title477": "该奖励已领取",
		"title478": "本周已领取",
		"title479": "本月已领取",
		"title480": "本日已领取",
		"title481": "帐号（请输入6-12个英文字母和数字）",
		"title482": "密碼（6~16個字符）",
		"title520": "活动详情",
		"title521": "领取",
		"title522": "每日签到奖金制度，只要您完成要求的条件，即可获得签到奖金。",
		"title523": "每日签到逢星期一00:00重置签到日数。",
		"title524": "抽奖次数如何获取？",
		"title525": "1.轮盘按每日充值自动派发。",
		"title526": "2.轮盘点数详情可以查看优惠中心。",
		"title527": "⚠️ 注意：",
		"title528": "1.轮盘点数需当天使用。",
		"title529": "2.当天剩余的轮盘点数不保留，隔天00:00重置。",
		"title530": "3.您获得轮盘奖金，需完成 1 倍有效投注后即可提款",
		"title531": "彩金库",
		"title532": "余额宝",
		"title533": "彩金随时领",
		"title534": "闲钱享收益",
		"title535": "总金额 (HK$)",
		"title536": "年利率",
		"title537": "转入",
		"title538": "领取",
		"title539": "转出",
		"title540": "当前收益",
		"title541": "总计彩金",
		"title542": "累计收益",
		"title543": "明细详情",
		"title544": "余额宝规则",
		"title545": "收益明细",
		"title546": "领取记录",
		"title547": "转出记录",
		"title548": "转入记录",
		"title549": "收益",
		"title550": "暂无记录",
		"title551": "中心钱包余额",
		"title552": "余额宝余额",
		"title553": "请输入金额",
		"title554": "确认",
		"title555": "利息规则\n• 主账户资金需满足提款码量后才能转入余额宝。\n• 按年利率计算，每小时为一个结算周期，收益公式如下：\n余额宝金额 × 年利率 ÷ 365 ÷ 24 = 每小时收益。\n• 需存入 2 小时后才开始计算收益，转出彩金奖励不受影响。\n• 单次存入的最高结算周期为 12 小时，超过 12 小时需重新存入才能继续计算利息。\n• 以 365 % 年利率为例，若余额宝金额为 100,000 HKD，则12小时的利息收益约为 500 HKD。\n\n转出规则\n奖励比例：\n• 每笔从余额宝转出至主账户才获得1%彩金奖励，每天最多2次，1%奖励上限为388 HKD。\n转出要求：\n• 转出至主帐户后，需完成 「转出金额 + 彩金」的 1 倍打码量方可提款。",
		"title556": "操作失败，请稍后重试",
		"title557": "主钱包余额(HK$)",
		"title558": "利息宝钱包(HK$)",
		"title559": "转入金额",
		"title560": "提现密码",
		"title561": "主账户金额需完成打码量并满足提款条件后，方可转入利息宝。可通过打码量检查是否符合转入条件。",
		"title562": "转出",
		"title563": "全部余额",
		"title564": "未领取收益",
		"title565": "转出金额",
		"title566": "赠送金额",
		"title567": "彩金奖励规则：",
		"title568": "1.转出赠送{rate}%，2次/天",
		"title569": "2.转出后「本金+彩金」需要完成1倍打码量",
		"title572": "到账合计",
		"title573": "转出赠送",
		"title574": "彩金库",
		"title575": "可领取",
		"title576": "进行中",
		"title577": "已领取",
		"title578": "已过期",
		"title579": "积分中心",
		"title580": "优先打码中",
		"title581": "刷新",
		"title582": "奖金",
		"title583": "首存最高赠送150% - 打码领取",
		"title584": "所需打码量",
		"title585": "打码开始时间",
		"title586": "打码截止时间",
		"title587": "有效打码游戏",
		"title588": "已完成",
		"title589": "当前打码",
		"title590": "还需",
		"title591": "分段奖励领取",
		"title592": "总奖励",
		"title593": "已领取",
		"title594": "第",
		"title594b": "档",
		"title595": "进度 ≥",
		"title596": "已达标，可立即领取该档奖励",
		"title597": "领取奖励",
		"title598": "尚未达到进度要求",
		"title599": "未达标",
		"title600": "暂无进行中的彩金",
		"title601": "真人(计20%)、体育(计100%)、棋牌(计100%)、电子(计100%)、电竞(计100%)、捕鱼(计100%)",
		"title602": "暂无可领取彩金",
		"title603": "暂无已领取记录",
		"title604": "暂无已过期记录",
		"title605": "积分中心即将开放",
		"title606": "设为优先打码",
		"title607": "累计领取金额",
		"title608": "没有更多了",
		"title609": "VIP奖金",
		"title610": "人工优惠",
		"title611": "所获奖励",
		"title612": "热门游戏",
		"title613": "小游戏",
		"title614": "搜索游戏...",
		"title615": "未找到游戏",
		"title616": "暂无热门游戏",
		"title617": "暂无小游戏",
		"title618": "暂无真人游戏",
		"title619": "暂无游戏",
		"title620": "返回厂商",
		"title621": "中奖榜",
		"title622": "加载中",
		"title623": "用户",
		"title624": "倍数",
		"title625": "赢分",
		"title626": "切换语言",
		"title627": "新",
		"title628": "热",
		"title629": "专属优惠等你领取",
		"title630": "查看详情",
		"title631": "暂无优惠",
		"title632": "欢迎回来",
		"title633": "登录后开始游戏",
		"title634": "还没有账号？",
		"title635": "创建账号",
		"title636": "注册后开始游戏",
		"title637": "账号信息",
		"title638": "下一步",
		"title639": "银行信息",
		"title640": "请选择银行",
		"title641": "已有账号？",
		"title642": "排行",
		"title643": "请输入完整姓名",
		"title644": "确认密码",
		"title645": "登录失败",
		"title646": "注册失败",
		"title647": "验证码发送失败",
		"title648": "密码至少6位",
		"title649": "请输入姓名",
		"title650": "投注",
		"title651": "银行账号 / PromptPay",
		"title652": "游玩记录",
		"title653": "暂无游玩记录",
		"title654": "联系渠道",
		"title655": "24小时服务",
		"title656": "快速响应",
		"title657": "安全聊天",
		"title658": "选择一种联系方式",
		"title659": "立即聊天",
		"title660": "暂无客服渠道",
		"title661": "LINE",
		"title662": "你的等级",
		"title663": "累计存款",
		"title664": "已达最高等级",
		"title665": "所有等级",
		"title666": "当前的",
		"title667": "渠道",
		"title668": "数量",
		"title669": "付款",
		"title670": "剩余余额",
		"title671": "您的账户",
		"title672": "选择付款方式",
		"title673": "选定渠道",
		"title674": "请选择金额",
		"title675": "或者指定数量",
		"title676": "请指定金额",
		"title677": "最低存款额",
		"title678": "泰铢",
		"title679": "银行转账 + 上传凭证",
		"title680": "在线支付",
		"title681": "收款账户",
		"title682": "银行",
		"title683": "钱包",
		"title684": "暂未开通钱包提现",
		"title685": "最低提款额",
		"title686": "最高提款额",
		"title687": "提取",
		"title688": "最低取款金额：",
		"title689": "USDT地址",
		"title690": "请输入USDT收款地址",
		"title691": "绑定USDT",
		"title692": "已绑定",
		"title693": "请先绑定USDT地址",
		"title694": "网络类型",
		"title695": "退还您的游戏余额。",
		"title696": "退款损失",
		"title697": "昨日亏损总额",
		"title698": "亏损金比例",
		"title699": "可领取金额",
		"title700": "加载中...",
		"title701": "领取中...",
		"title702": "今日已领取",
		"title703": "暂无可领取亏损金",
		"title704": "领取",
		"title705": "领取成功",
		"title706": "退还您昨天投注的损失。",
		"title707": "要求退还昨天的损失。",
		"title708": "没有符合退款条件的损失（你昨天没有亏钱）。",
		"title709": "如何申请损失赔偿。",
		"title710": "玩游戏，累积投注积分。",
		"title711": "损失计算方法为：总投注额 - 总赢额 - 前一日的回滚金额。",
		"title712": "如果您遭受损失，您可以每天获得退款。",
		"title713": "返现比例取决于您的等级。",
		"title714": "损失退款历史",
		"title715": "没有收到损失赔偿的记录。",
		"title716": "返还昨日投注金额。",
		"title717": "申请退还昨天投注金额。",
		"title718": "获得返现没有最低投注要求。",
		"title719": "如何获得返现",
		"title720": "玩游戏，累积投注积分。",
		"title721": "返现金额将根据前一天的投注金额计算。",
		"title722": "每天都可以回来领取您的现金返利！",
		"title723": "返现比例取决于您的等级。",
		"title724": "返现收据历史记录",
		"title725": "返现",
		"title726": "目前还没有收到返现的记录。",
		"title727": "幸运轮",
		"title728": "您的门票",
		"title729": "今日可用",
		"title730": "车轮",
		"title731": "记录",
		"title732": "转动轮盘",
		"title733": "张彩票",
		"title734": "票不够。",
		"title735": "每次消耗 1 张门票",
		"title736": "所有奖项",
		"title737": "奖品",
		"title738": "报到",
		"title739": "所有报到",
		"title740": "累积积分",
		"title741": "分",
		"title742": "完成条件即可领取签到奖金。",
		"title743": "立即签到",
		"title744": "已办理报到",
		"title745": "今天",
		"title746": "签到规则",
		"title747": "签到需完成当日充值金额与当日有效投注条件（以当日档位要求为准），达标后方可领取签到奖金。",
		"title748": "若中断未签到，连续天数将重新从第 1 天开始；累计签到天数越高，奖励更丰厚。",
		"title749": "在积分商店收集积分并兑换奖励。",
		"title750": "达标后签到可领取 <em>{n}</em> 奖金。",
		"title751": "年",
		"title752": "月",
		"title753": "日,一,二,三,四,五,六",
		"title570": "请输入6位提现密码",
		"title571": "暂无可转出余额",
		"title483": "請輸入英文姓名（可含空格）",
		"title484": "请输入手机号码",
		"title485": "提款密码（6位数字组成）",
		"title486": "請輸入舊提款密碼",
		"title487": "验证码",
		"title487Err": "请输入验证码",
		"title488": "获取验证码",
		"title489": "帐号登入",
		"title490": "手机登入",
		"title491": "忘记密码",
		"title492": "设置新密码",
		"title493": "确认修改",
		"title494": "已領取佣金獎勵",
		"title495": "删除",
		"title496": "删除银行卡",
		"title497": "取消",
		"title498": "确认删除",
	},

};